import { render, staticRenderFns } from "./textEdit.vue?vue&type=template&id=5f57fd8e&scoped=true&"
import script from "./textEdit.vue?vue&type=script&lang=js&"
export * from "./textEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57fd8e",
  null
  
)

export default component.exports